module.exports = __webpack_public_path__ + "static/media/3.fbf1b2f9.jpg";